<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showAdvancedInfoDiv' > 
                                {{sortType == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Status" >
                                <select class="form-control" size="large" v-model="inputStatus">
                                    <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                        Separate Per Site
                    </base-checkbox>

                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                        Advanced Filter
                    </button> 

                    <div v-if="toggleAdvanceFilter" class="col-md-12">
                        <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="filterVisible">
                            <advance-filter :parentParams="filterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
                        </a-drawer>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils.js';
    
    import {
        mapState
    } from 'vuex'

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputGroupBy: 'none',
                groupOptions: [
                    {key: 'none', value: 'No Grouping'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                ],
                inputStatus: 'all',
                statusOptions: [
                    {key: 'all', value: 'All'},
                    {key: 'available', value: 'Available'},
                    {key: 'unavailable', value: 'Unavailable'},
                ],
                inputSortBy: 'name',
                sortOptions: [
                    {key: 'name', value: 'Name or Description'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                ],
                sortType: 'asc',
                isSeparateSite: false,

                currDate: moment().format("L_LT").split(":").join(";"),
                toggleAdvanceFilter: false, 
                toggleLabel: "Advanced Filter",
                filterParams: {},
                params: {},
                filterVisible: true,
                JsonData: []

            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
            this.documentTypeOptions = document_types


        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            changeParams(params, actualParams, mode){
                this.params = params
                this.filterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            showAdvancedInfoDiv(){
                this.sortType == 'asc' ? this.sortType = 'desc' : this.sortType = 'asc'
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters. ');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                let parameters = {
                    "site_id": this.inputSite,
                    "sort_by": this.inputSortBy,
                    "group_by": this.inputGroupBy,
                    "status": this.inputStatus,
                    "sort_type": this.sortType,
                    "is_separate_site": this.isSeparateSite,
                    "advanced_filter": this.params
                }

                var serials = await HTTPRequest.getRequest(this.endPoint + 'serial_item_reports', parameters)
                if(serials.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_detail = [];
            
                    if (this.isSeparateSite == true) {
                        if (this.inputGroupBy == 'none') {
                            header_detail.push(
                                {content: 'Brand', styles: {halign: 'center'}},
                                {content: 'Supplier', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        } else if (this.inputGroupBy == 'supplier_id') {
                            header_detail.push(
                                {content: 'Brand', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        } else if (this.inputGroupBy == 'brand_id') {
                            header_detail.push(
                                {content: 'Supplier', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        }
                    } else {
                        if (this.inputGroupBy == 'none') {
                            header_detail.push(
                                {content: 'Brand', styles: {halign: 'center'}},
                                {content: 'Supplier', styles: {halign: 'center'}},
                                {content: 'Site', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        } else if (this.inputGroupBy == 'supplier_id') {
                            header_detail.push(
                                {content: 'Brand', styles: {halign: 'center'}},
                                {content: 'Site', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        } else if (this.inputGroupBy == 'brand_id') {
                            header_detail.push(
                                {content: 'Supplier', styles: {halign: 'center'}},
                                {content: 'Site', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Item Description', styles: {halign: 'center'}},
                                {content: 'Serial Number', styles: {halign: 'center'}},
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Status', styles: {halign: 'center'}}
                            )
                        }
                    }

                    headers = [header_detail]
                    let reportData = []

                    let site_prev_grouper = ''
                    let site_current_grouper = ''
                    let prev_grouper = ''
                    let current_grouper = ''
                    for(let i=0; i < serials.length; i++){
                        let reportLine = serials[i]

                        if (this.isSeparateSite == true) {
                            if (serials[i-1]) {
                                site_prev_grouper = serials[i-1].SITE_NAME
                                site_current_grouper = reportLine.SITE_NAME
                                if (site_prev_grouper != site_current_grouper) {
                                    let site_detail_header = [{content: site_current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, site_detail_header))
                                }
                            } else {
                                site_current_grouper = reportLine.SITE_NAME
                                let site_detail_header = [{content: site_current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                reportData.push(Object.assign({}, site_detail_header))
                            }

                            //BODY
                            let detail = []
            
                            if (this.inputGroupBy == 'none') {
                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'supplier_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].SUPPLIER_NAME
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                }

                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].BRAND_NAME
                                    current_grouper = reportLine.BRAND_NAME

                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.BRAND_NAME
                                    let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                }
                                detail.push(
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            }
                            reportData.push(Object.assign({}, detail))

                        } else {
                            //BODY
                            let detail = []
            
                            if (this.inputGroupBy == 'none') {
                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'supplier_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].SUPPLIER_NAME
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                }

                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].BRAND_NAME
                                    current_grouper = reportLine.BRAND_NAME

                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.BRAND_NAME
                                    let detail_header = [{content: current_grouper, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                }
                                detail.push(
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            }
                            reportData.push(Object.assign({}, detail))
                        }



                    if (this.isSeparateSite == true) {
                        if (serials[i+1]) {
                            if (this.inputGroupBy == 'supplier_id') {
                                if (reportLine.SUPPLIER_NAME != serials[i+1].SUPPLIER_NAME) {
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                }
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (reportLine.BRAND_NAME != serials[i+1].BRAND_NAME) {
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                }
                            }
                            if (reportLine.SITE_NAME != serials[i+1].SITE_NAME) {
                                reportData.push(Object.assign({}, ["rowLine"]))
                            }
                        }
                    } else {
                        if (serials[i+1]) {
                            if (this.inputGroupBy == 'supplier_id') {
                                if (reportLine.SUPPLIER_NAME != serials[i+1].SUPPLIER_NAME) {
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                }
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (reportLine.BRAND_NAME != serials[i+1].BRAND_NAME) {
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                }
                            }
                        }
                    }

                       

                    }

                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"Serial Item Report")
                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    

                    let site_text = ''
                    if(this.inputSite.length == 0){
                        site_text = 'All Sites'
                    } else {
                        let sites = this.inputSite
                        for (var s = 0; s < sites.length; s++) {
                            if(s == 0){
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }
                    doc.text(340,20,site_text,"right");
                    
                    doc.autoTable({
                        startY: 35, 
                        head: headers, 
                        body: reportData, 
                        theme: 'plain',
                        tableWidth: 'wrap',
                        headStyles: {
                            lineWidth: 0.15,
                            cellPadding: 2
                        },
                        styles: {
                            cellPadding: 1.0, fontSize: 10,
                        },
                        didParseCell: function(data) {
                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                data.cell.styles.fillColor = [0, 0, 0]
                                data.cell.styles.fontSize = 1
                                data.cell.styles.cellPadding = 0
                            }
                        }
                    });


                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    
                    doc.text(15,200,"Printed By: " + printed_by)
                    doc.text(340,200,"Serial Item Report", "right")

                    doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                    //doc.text(340,205,"Page " + ( x + 1)  + " of " + serials.length, "right")
                    
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Stock_Valuation_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters. ');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                let parameters = {
                    "site_id": this.inputSite,
                    "sort_by": this.inputSortBy,
                    "group_by": this.inputGroupBy,
                    "status": this.inputStatus,
                    "sort_type": this.sortType,
                    "is_separate_site": this.isSeparateSite,
                    "advanced_filter": this.params
                }

                var serials = await HTTPRequest.getRequest(this.endPoint + 'serial_item_reports', parameters)
                if(serials.length > 0){
                    let headers = [];
                    let header_detail = [];
                    let site_specific = [];
                    if (this.isSeparateSite == true) {
                        if (this.inputGroupBy == 'none') {
                            header_detail.push('Brand','Supplier','Barcode','Item Description','Serial Number','Date','Status')
                        } else if (this.inputGroupBy == 'supplier_id') {
                            header_detail.push('Brand','Barcode','Item Description','Serial Number','Date','Status')
                        } else if (this.inputGroupBy == 'brand_id') {
                            header_detail.push('Supplier','Barcode','Item Description','Serial Number','Date','Status')
                        }
                    } else {
                        if (this.inputGroupBy == 'none') {
                            header_detail.push('Brand','Supplier','Site','Barcode','Item Description','Serial Number','Date','Status')
                        } else if (this.inputGroupBy == 'supplier_id') {
                            header_detail.push('Brand','Site','Barcode','Item Description','Serial Number','Date','Status')
                        } else if (this.inputGroupBy == 'brand_id') {
                            header_detail.push('Supplier','Site','Barcode','Item Description', 'Serial Number','Date','Status')
                        }
                    }

                    headers = header_detail
                    let reportData = []

                    let site_prev_grouper = ''
                    let site_current_grouper = ''
                    let prev_grouper = ''
                    let current_grouper = ''
                    for(let i = 0; i < serials.length; i++){
                        let reportLine = serials[i]

                        if (this.isSeparateSite == true) {
                            if (serials[i-1]) {
                                site_prev_grouper = serials[i-1].SITE_NAME
                                site_current_grouper = reportLine.SITE_NAME
                                if (site_prev_grouper != site_current_grouper) {
                                    let site_detail_header = [site_current_grouper];
                                    reportData.push(Object.assign({}, site_detail_header))
                                }
                            } else {
                                site_current_grouper = reportLine.SITE_NAME
                                let site_detail_header = [site_current_grouper];
                                reportData.push(Object.assign({}, site_detail_header))
                            }

                            //BODY
                            let detail = []
            
                            if (this.inputGroupBy == 'none') {
                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'supplier_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].SUPPLIER_NAME
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [current_grouper];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    let detail_header = [current_grouper];
                                    reportData.push(Object.assign({}, detail_header))
                                }

                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].BRAND_NAME
                                    current_grouper = reportLine.BRAND_NAME

                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [current_grouper];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.BRAND_NAME
                                    let detail_header = [current_grouper];
                                    reportData.push(Object.assign({}, detail_header))
                                }
                                detail.push(
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            }
                            reportData.push(Object.assign({}, detail))

                        } else {
                            //BODY
                            let detail = []
            
                            if (this.inputGroupBy == 'none') {
                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'supplier_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].SUPPLIER_NAME
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [current_grouper];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.SUPPLIER_NAME
                                    let detail_header = [current_grouper];
                                    reportData.push(Object.assign({}, detail_header))
                                }

                                detail.push(
                                    reportLine.BRAND_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            } else if (this.inputGroupBy == 'brand_id') {
                                if (serials[i-1]) {
                                    prev_grouper = serials[i-1].BRAND_NAME
                                    current_grouper = reportLine.BRAND_NAME

                                    if (prev_grouper != current_grouper) {
                                        let detail_header = [current_grouper];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                } else {
                                    current_grouper = reportLine.BRAND_NAME
                                    let detail_header = [current_grouper];
                                    reportData.push(Object.assign({}, detail_header))
                                }
                                detail.push(
                                    reportLine.SUPPLIER_NAME,
                                    reportLine.SITE_NAME,
                                    reportLine.BARCODE,
                                    reportLine.PRODUCT_NAME,
                                    reportLine.SERIAL_NUMBER,
                                    reportLine.DATE,
                                    reportLine.STATUS
                                )
                            }
                            reportData.push(Object.assign({}, detail))
                        }
                    }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    reportData.push(["Serial Item Report", "Generate By: " + printed_by])

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(let i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(this, 'error', 'No records returned. Please make sure to check your filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>